import { BasicButton } from "@components/common/buttons/BasicButton";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useAuth } from "@hooks";
import { useTeam } from "@hooks";
import { Avatar, AvatarGroup, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { AccountItem, AccountItemLine } from "../AccountItem";
import FeatureToggle from "../FeatureToggle";
import SelectTeam from "./SelectTeam";

export default function TeamSettings() {
  const { currentTeam, setCurrentTeam } = useTeam();
  const { userTeams } = useAuth();
  const navigate = useNavigate();
  if (!currentTeam?.uuid) {
    return null;
  }

  return (
    <AccountItem
      title="Team"
      icon={<FontAwesomeIcon icon={faUsers} size="lg" color="gray" />}
    >
      {currentTeam?.uuid ? (
        <div className="flex-1 flex mr-4 md:space-x-4">
          <div className="flex-1 divide-y dark:divide-gray-700">
            <AccountItemLine title="Current Team Name:">
              {currentTeam?.name}
              <AvatarGroup max={8}>
                {currentTeam?.users?.map((user) => (
                  <Tooltip
                    key={user.uuid}
                    arrow
                    placement="top"
                    title={`${user?.firstName}
              ${user?.lastName}`}
                  >
                    <Avatar
                      sx={{ width: 24, height: 24, fontSize: 10 }}
                    >
                      {user?.firstName.charAt(0)}
                      {user?.lastName.charAt(0)}
                    </Avatar>
                  </Tooltip>
                ))}
              </AvatarGroup>
            </AccountItemLine>

            {userTeams?.length && userTeams.length > 1 ? (
              <AccountItemLine title="Switch Current Team:">
                <SelectTeam
                  currentTeam={currentTeam}
                  setCurrentTeam={setCurrentTeam}
                  showLabel={false}
                />
              </AccountItemLine>
            ) : null}

            <AccountItemLine>
              <FeatureToggle
                title="Transfer New Notes"
                description={
                  <>
                    Turning this setting on will open a menu to
                    transfer new recordings after pressing the stop
                    button.
                    <br />
                    <br />
                    <i>When to use:</i> This setting is useful if
                    you're primarily recording on behalf of other
                    members of the care team (eg. when assisting a
                    DVM).
                    <br />
                    <br />
                    <i>When not to use:</i> If you want to maintain
                    ownership of your notes (eg. if you are a DVM).
                  </>
                }
                flagKey="transferNewNotes"
                segmentKey="transfer-new-notes"
              />
            </AccountItemLine>
          </div>
        </div>
      ) : (
        <div className="w-full flex flex-row items-center justify-between">
          Teams Mode allows you to use Scribenote with your clinic,
          letting you share notes and templates. Invite your team to
          get started!
          <BasicButton
            importance="primary"
            size="sm"
            onClick={() => navigate("/teams")}
          >
            Invite My Team
          </BasicButton>
        </div>
      )}
    </AccountItem>
  );
}
